import { render, staticRenderFns } from "./NiftyGauge.vue?vue&type=template&id=4d9a73a9&scoped=true&"
import script from "./NiftyGauge.vue?vue&type=script&lang=js&"
export * from "./NiftyGauge.vue?vue&type=script&lang=js&"
import style0 from "./NiftyGauge.vue?vue&type=style&index=0&id=4d9a73a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9a73a9",
  null
  
)

export default component.exports